/**
 * created by li si yi
 * 消息模板配置
 */
import React, {Component} from 'react';
import {Tabs, Table, Upload, Button, message, Row, Col, Select, Input, Icon, Modal, Popconfirm, Pagination} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";

const {Option} = Select;
const {TabPane} = Tabs;

class NoticeTemplateManager extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: false,
            column: [],
            dataSource: [],
            selectedRows: [],
            tabsInfo: [
                {
                    key: "1",
                    name: '模板管理'
                },
                {
                    key: "2",
                    name: 'POJO对象管理'
                },
                {
                    key: "3",
                    name: '业务管理'
                },
                {
                    key: "4",
                    name: '类型管理'
                }
            ],
            addKeyToModalTitle: {'1': '模板', '2': "POJO对象", '3': '业务', '4': '类型'},
            saveKeyToUrl: {'1': '/addTemplateInfo', '2': "/addPojoInfo", '3': '/addBusinessInfo', '4': '/addTypeInfo'},
            getKeyToUrl: {'1': '/getTemplateInfo', '2': "/getPojoInfo", '3': '/getBusinessInfo', '4': '/getTypeInfo'},
            updateKeyToUrl: {
                '1': '/updateTemplateInfo',
                '2': "/updatePojoInfo",
                '3': '/updateBusinessInfo',
                '4': '/updateTypeInfo'
            },
            deleteKeyToUrl: {
                '1': '/delTemplateInfo',
                '2': "/delPojoInfo",
                '3': '/delBusinessInfo',
                '4': '/delTypeInfo'
            },
            count: 0,
            activeKey: '1',
            templateFlag: true,
            selectedRowKeys: [],
            templateVisible: false,
            modalTitle: '新增模板',
            pojoSelects: [],
            businessSelects: [],
            typeSelects: [],
            baseUrl: '/cm-sites-sys/noticeTemplateController',
            formData: {
                name: '',
                code: '',
                typeCode: '',
                pojoCode: '',
                businessCode: '',
                title: '',
                content: '',
                spliceUrlTemplate: ''
            },
            isEdit: false,
            selectedRowsIds: [],//批量删除
            params: {
                templateInfo: {},
                businessInfo: {},
                pojoInfo: {},
                typeInfo: {},
                page: {
                    start: 1,
                    size: 10,
                },
            },
            page: {
                start: 1,
                size: 2147483647
            },
        };
        this.updateData = this.updateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.addData = this.addData.bind(this);
    }

    uploadConfig = {
        name: 'file',
        action: '/cm-sites-sys/importBaseData',
        method: 'post',
        showUploadList: false,
        multiple: false,
        onChange: this.uploading.bind(this),
    };

    componentDidMount() {
        this.setColumnByKey(1);
        //获取列表数据；
        this.getDataSource(1);
    }

    getDataSource(key, status = true) {
        let that = this;
        let queryUrl = this.state.baseUrl + this.state.getKeyToUrl[key];
        let params;
        if (this.state.activeKey === '1' && this.state.templateVisible) {
            params = this.state.page
        } else {
            params = this.state.params;
        }
        this.request({
            url: queryUrl,
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                if (res) {
                    if (key == 2) {
                        that.setState({
                            pojoSelects: res.data
                        })
                    } else if (key == 3) {
                        that.setState({
                            businessSelects: res.data
                        })
                    } else if (key == 4) {
                        that.setState({
                            typeSelects: res.data
                        })
                    }
                    if (status) {
                        that.setState({
                            count: res.count,
                            dataSource: res.data ? res.data : res
                        });
                    }
                }
            }
        })
    }

    setColumnByKey(tabkey) {
        if (tabkey == 1) {
            this.setState({
                column: [
                    {
                        key: '1',
                        title: '对象名称',
                        dataIndex: 'pojoName',
                        ellipsis: true,
                        render: (text, record) => {
                            if (record.pojoName && record.pojoName.length) {
                                return (
                                    <div>{record.pojoName[0].name}</div>
                                )
                            }
                        }
                    },
                    {
                        key: '2',
                        title: '业务名称',
                        dataIndex: 'businessName',
                        textWrap: 'word-break',
                        ellipsis: true,
                        render: (text, record) => {
                            return (
                                <div>{record.name ? record.name : ""}</div>
                            )
                        }
                    },
                    {
                        key: '3',
                        title: '类型名称',
                        dataIndex: 'typeName',
                        textWrap: 'word-break',
                        ellipsis: true,
                        render: (text, record) => {
                            return (
                                <div>{record.typeName && record.typeName[0] ? record.typeName[0].name : ''}</div>
                            )
                        }
                    },
                    {
                        key: '4',
                        title: '消息模板名称',
                        dataIndex: 'name',
                        textWrap: 'word-break',
                        ellipsis: true,
                    },
                    {
                        key: '5',
                        title: '消息模板标题',
                        dataIndex: 'title',
                        textWrap: 'word-break',
                        ellipsis: true,
                    },
                    {
                        key: '6',
                        title: '消息模板内容',
                        dataIndex: 'content',
                        textWrap: 'word-break',
                        ellipsis: true,
                    },
                    {
                        key: '7',
                        title: '操作',
                        dataIndex: 'operate',
                        textWrap: 'word-break',
                        ellipsis: true,
                        render: (value, row) => {
                            return (
                                <>
                                    <span style={{
                                        padding: '3px 10px',
                                        background: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                        color: '#fff',
                                        borderRadius: 5,
                                        marginRight: 10,
                                        cursor: 'pointer'
                                    }} onClick={() => {
                                        this.updateData(row)
                                    }}>修改</span>
                                    <Popconfirm
                                        title="确定要删除吗？"
                                        onConfirm={() => {
                                            this.deleteData(row)
                                        }}
                                        okText="确定"
                                        cancelText="取消"
                                    >
                                        <span style={{
                                            padding: '3px 10px',
                                            background: this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3"),
                                            color: '#fff',
                                            borderRadius: 5,
                                            marginRight: 10,
                                            cursor: 'pointer'
                                        }}>删除</span>
                                    </Popconfirm>

                                </>
                            )
                        }
                    }
                ]
            })
        } else {
            this.setState({
                column: [
                    {
                        key: '1',
                        title: 'CODE',
                        dataIndex: 'code',
                        ellipsis: true
                    },
                    {
                        key: '2',
                        title: '名称',
                        dataIndex: 'name',
                        textWrap: 'word-break',
                        ellipsis: true
                    },
                    {
                        key: '7',
                        title: '操作',
                        dataIndex: 'operate',
                        textWrap: 'word-break',
                        ellipsis: true,
                        render: (value, row) => {
                            return <>
                                <span style={{
                                    padding: '3px 10px',
                                    background: this.themeBgColor,
                                    color: '#fff',
                                    borderRadius: 5,
                                    marginRight: 10,
                                    cursor: 'pointer'
                                }} onClick={() => {
                                    this.updateData(row)
                                }}>修改</span>
                                <Popconfirm
                                    title="确定要删除吗？"
                                    onConfirm={() => {
                                        this.deleteData(row)
                                    }}
                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <span style={{
                                        padding: '3px 10px',
                                        background: this.themeBgColor,
                                        color: '#fff',
                                        borderRadius: 5,
                                        marginRight: 10,
                                        cursor: 'pointer'
                                    }}>删除</span>
                                </Popconfirm>
                            </>
                        }
                    }
                ]
            })
        }
    }

    /**
     * 修改数据
     * @param data
     */
    updateData = (data) => {
        this.clearFormData();
        let formData = {...data};
        this.setState({
            formData,
            templateVisible: true,
            isEdit: true,
        }, () => {
            //需要加载下拉列表。pojo,business,type的下拉选择框。
            if (this.state.activeKey == '1') {
                this.getDataSource(2, false);  //pojo的下拉选数据
                this.getDataSource(3, false);   //business的下拉选数据
                this.getDataSource(4, false);  //类型的下拉选数据；
            }
        })
    };

    /**
     * 删除数据
     * @param data
     */
    deleteData = (data) => {
        const {deleteKeyToUrl, activeKey, selectedRowsIds} = this.state;
        let url = this.state.baseUrl + deleteKeyToUrl[activeKey];
        this.deleteFromData(data, activeKey, url, selectedRowsIds);
    };
    //删除单个/多个
    deleteFromData = (data, activeKey, url, selectedRowsIds) => {
        message.destroy();
        let params;
        if (data && (data._id || data.code)) {
            params = [];
            params.push(data._id || data.code);//删除单个
        } else {
            params = [];//删除多个
            selectedRowsIds.forEach(item => {
                params.push(item._id || item.code);
            });
        }
        if (!params.length) {
            message.error('请勾选要删除的内容！')
            return
        }
        this.request({
            url: url,
            body: params,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    message.success('删除成功');
                    this.getDataSource(activeKey);
                } else {
                    message.error('删除失败!');
                }
            }
        });
    };

    uploading(info) {
        // console.log(info.file.status);
        message.destroy();
        if (info.file.status === 'uploading') {
            this.setState({
                loading: true
            })
        }
        if (info.file.status === 'done') {
            this.setState({
                loading: false,
            });
            message.success(`导出成功`);
        } else if (info.file.status === 'error') {
            this.setState({
                loading: false,
            });
            message.error('导出失败!');
        }
    }

    /**
     * 清空form表单的数据
     */
    clearFormData() {
        this.setState({
            formData: {
                name: '',
                code: '',
                typeCode: '',
                pojoCode: '',
                businessCode: '',
                title: '',
                content: '',
            }
        });
    }

    tabChange(key) {
        //设置表格的列
        this.setColumnByKey(key);
        this.state.params.page.start = 1;
        this.state.params.page.size = 10;
        this.setState({activeKey: key});
        //获取列表数据；
        this.getDataSource(key);
        if (key === '1') {
            this.setState({templateFlag: true});
        } else {
            this.setState({templateFlag: false});
        }
    }

    /**
     * 导出基础数据
     */
    exportDatas() {
        message.destroy();
        let data = this.state.selectedRows;
        if (!data || data.length == 0) {
            message.error('请选择要导出的表!');
            return;
        }
        let tablenames = [];
        for (var i = 0; i < data.length; i++) {
            tablenames.push(data[i].name);
        }
        var url = "/cm-sites-sys/wrongWord/wrongWordExpot";
        this.exportData(url);
    }

    // 导出
    exportData(url) {
        let params = {tableName: this.state.tableName};
        this.request({
            url: url,
            method: 'downloadPost',
            body: params,
        });
    }

    //复选框
    onSelectChange = (selectedRowKeys, selectedRows) => {
        // console.log('selectedRowKeys changed: ', selectedRowKeys, 'selectedRows:', selectedRows);
        this.setState({selectedRowKeys, selectedRowsIds: selectedRows});
    };

    /**
     * 新增数据
     */
    addData() {
        let modalTitle = "新增" + this.state.addKeyToModalTitle[this.state.activeKey];
        //清空表单的数据
        this.clearFormData();
        this.setState({
            modalTitle,
            templateVisible: true,
            isEdit: false,
        }, () => {
            //需要加载下拉列表。pojo,business,type的下拉选择框。
            if (this.state.activeKey == '1') {
                this.getDataSource(2, false);  //pojo的下拉选数据
                this.getDataSource(3, false);   //business的下拉选数据
                this.getDataSource(4, false);  //类型的下拉选数据；
            }
        });
    }

    /**
     * 清空数据
     */
    revert = () => {
        this.setState({
            templateVisible: false,
        })
    };

    onChangeData = (attr, value) => {
        let formData = this.state.formData;
        formData[attr] = value;
        this.setState({
            formData,
        });
    };

    /**
     * 保存数据
     */
    saveDate = () => {
        const {formData, saveKeyToUrl, activeKey, updateKeyToUrl, templateVisible} = this.state;
        let checkResult = this.validataFormData();
        if (!checkResult) {
            return;
        }
        let url = null;
        if (formData._id || formData.id) {
            url = this.state.baseUrl + updateKeyToUrl[activeKey];
            formData.id = formData._id || formData.id;
        } else {
            url = this.state.baseUrl + saveKeyToUrl[activeKey];
        }
        this.request({
            url: url,
            method: 'post',
            contentType: (formData._id || formData.id) && activeKey != 1 ? 'x-www-form-urlencoded' : 'json',
            body: formData,
            callBack: (res1) => {
                let res = JSON.parse(res1);
                if (res.code == 0) {
                    message.success('操作成功');
                    this.getDataSource(activeKey);
                    this.setState({
                        templateVisible: false
                    })
                } else if (res.code == 1) {
                    message.success('操作成功');
                    this.getDataSource(activeKey);
                    this.setState({
                        templateVisible: false
                    });
                } else {
                    if (formData.id) {
                        message.success('修改成功');
                    } else {
                        message.success('添加成功');
                    }
                    this.setState({
                        templateVisible: false
                    }, () => {
                        this.getDataSource(activeKey);
                    });
                }
            }
        })
    };

    /**
     * 校验form的数据有效性
     */
    validataFormData = () => {
        const {templateFlag, formData} = this.state;
        message.destroy();
        if (!templateFlag && !formData.code) {
            message.error('请填写编码!');
            return false;
        }
        if (!formData.name) {
            message.error('请填写名称!');
            return false;
        }
        if (templateFlag) {
            if (!formData.typeCode) {
                message.error('请填写类型!');
                return false;
            }

            if (!formData.businessCode) {
                message.error('请填写业务名称!');
                return false;
            }

            if (!formData.pojoCode) {
                message.error('请填写POJO!');
                return false;
            }


            if (!formData.title) {
                message.error('请填写标题模板!');
                return false;
            }

            if (!formData.content) {
                message.error('请填写内容模板!');
                return false;
            }
        }
        return true;
    };

    // 导入数据
    uploadOnChange = (info) => {
        // console.log(info);
        if (info.file.status === 'done') {
            this.importFile(info.fileList[0]);
        }
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.md5 = info.file.response && info.file.response.md5;
                // item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.setState({
            fileList: info.fileList
        })
    };

    importData(file) {
        if (!file.response && !file.response.data && !file.response.data.md5) {
            return
        }
        let params = {
            tableName: file.response.data.name,
            md5: file.response.data.md5,
        };
        this.request({
            url: '/cm-sites-sys/data/import',
            method: 'post',
            body: params,
            callBack: (res) => {
                console.log(res)
            }
        })
    };

    render() {
        const {tabsInfo, selectedRowKeys, activeKey, templateFlag, formData, isEdit} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        return (<div style={{
                background: '#fff',
                maxHeight:"calc(100vh - 100px)",
                borderRadius: 5,
                margin: '15px'
            }}>
                <div className={'noticeTemplate'}>
                    <Tabs defaultActiveKey="1" forceRender={true} size={'Default'} onChange={this.tabChange.bind(this)}>
                        {tabsInfo.map((item, index) => {
                            return (
                                <TabPane tab={item.name} key={item.key}>
                                    <div style={{padding: '24px 32px'}}>
                                        <div key={index} style={{display: 'flex'}}>
                                            <div className={"importButton"}>
                                                <Button type={'primary'} onClick={() => {
                                                    this.addData();
                                                }}>新增数据</Button>
                                            </div>
                                            <div className={"importButton"}>
                                                <Popconfirm
                                                    title="确定要删除吗？"
                                                    onConfirm={() => {
                                                        this.deleteData();
                                                    }}
                                                    okText="确定"
                                                    cancelText="取消"
                                                >
                                                    <Button type={'primary'}>删除数据</Button>
                                                </Popconfirm>
                                            </div>
                                        </div>
                                        <Scrollbars  autoHide autoHeight autoHeightMax={"calc(100vh - 334px)"}>
                                            <BaseTable
                                                // bodyStyle={{height: 'calc(100vh - 325px)'}}
                                                // pagination={true}
                                                rowSelection={rowSelection}
                                                columns={this.state.column}
                                                dataSource={this.state.dataSource}
                                                rowKey="id"/>
                                        </Scrollbars>
                                        <style>{`
                                            .noticeTemplate .ant-table-pagination.ant-pagination {
                                                 margin:16px 30px !important;
                                            }
                                        `}</style>
                                    </div>
                                </TabPane>
                            )
                        })}
                    </Tabs>
                    <style>{`
                        .importButton{
                            margin-right:10px;
                            margin-bottom:24px;
                        }
                    `}</style>
                    <Modal
                        title={this.state.modalTitle}
                        visible={this.state.templateVisible}
                        onOk={() => {
                            this.saveDate();
                        }}
                        maskClosable={false}
                        onCancel={() => {
                            this.setState({
                                templateVisible: false,
                            }, () => {
                                this.getDataSource(activeKey);
                            });
                        }}
                        bodyStyle={{height: 350}}
                        width={800}
                    >
                        <div>
                            {templateFlag ? <Row>
                                <div style={{padding: 10}}>
                                    <Col span={4}>
                                        <div className={'myMediaTitle'}>
                                            <span style={{color: 'red', position: 'absolute', top: 3, left: 32}}>*</span>POJO名称：
                                        </div>
                                    </Col>
                                    <Col span={5}> <Select placeholder={'请输入POJO名称'} className={'myMediaContent'}
                                                           value={formData.pojoCode ? formData.pojoCode : []}
                                                           style={{width: '100%'}}
                                                           onSelect={(value) => {
                                                               this.onChangeData("pojoCode", value);
                                                           }}>
                                        {this.state.pojoSelects.map((item, i) => {
                                            return (
                                                <Option key={i} value={item.code}>{item.name}</Option>
                                            )

                                        })

                                        }
                                    </Select></Col>
                                    <Col span={4}>
                                        <div className={'myMediaTitle'}><span
                                            style={{color: 'red', position: 'absolute', top: 3, left: 40}}>*</span>业务名称：
                                        </div>
                                    </Col>
                                    <Col span={7}> <Select placeholder={'请输入业务名称'} className={'myMediaContent'}
                                                           value={formData.businessCode ? formData.businessCode : []}
                                                           style={{width: '100%'}}
                                                           onSelect={(value) => {
                                                               this.onChangeData("businessCode", value);
                                                           }}>
                                        {this.state.businessSelects.map((item, i) => {
                                            return (
                                                <Option key={i} value={item.code}>{item.name}</Option>
                                            )
                                        })
                                        }
                                    </Select></Col>
                                </div>
                            </Row> : ''}

                            <Row>
                                <div style={{padding: 10}}>
                                    {templateFlag ? <Col span={4}>
                                        <div className={'myMediaTitle'}><span
                                            style={{color: 'red', position: 'absolute', top: 3, left: 40}}>*</span>类型名称：
                                        </div>
                                    </Col> : ''}
                                    {templateFlag ?
                                        <Col span={7}> <Select placeholder={'请输入类型名称'} className={'myMediaContent'}
                                                               value={formData.typeCode ? formData.typeCode : []}
                                                               style={{width: '100%'}}
                                                               onChange={(value) => {
                                                                   this.onChangeData("typeCode", value)
                                                               }}>
                                            {this.state.typeSelects.map((item, i) => {
                                                return (
                                                    <Option key={i} value={item.code}>{item.name}</Option>
                                                )
                                            })
                                            }
                                        </Select></Col> : ''}
                                    {!templateFlag ? <Col span={4}>
                                        <div className={'myMediaTitle'}><span
                                            style={{color: 'red', position: 'absolute', top: 3, left: 68}}>*</span>编码：
                                        </div>
                                    </Col> : ''}
                                    {!templateFlag ? <Col span={7}><Input className={''} value={formData.code}
                                                                          disabled={isEdit ? true : false}
                                                                          onChange={(e) => {
                                                                              this.onChangeData("code", e.target.value);
                                                                          }} placeholder="请输入编码"/></Col> : ''}
                                </div>
                            </Row>

                            <Row>
                                <div style={{padding: 10}}>
                                    <Col span={4}>
                                        <div className={'myMediaTitle'}><span
                                            style={{color: 'red', position: 'absolute', top: 3, left: 68}}>*</span>名称：
                                        </div>
                                    </Col>
                                    <Col span={7}><Input className={''} value={formData.name}
                                                         onChange={(e) => {
                                                             this.onChangeData("name", e.target.value);
                                                         }} placeholder="请输入名称"/></Col>
                                </div>
                            </Row>

                            {templateFlag ? <Row>
                                <div style={{padding: 10}}>
                                    <Col span={4}>
                                        <div className={'myMediaTitle'}><span
                                            style={{color: 'red', position: 'absolute', top: 3, left: 40}}>*</span>标题模板：
                                        </div>
                                    </Col>
                                    <Col span={20}><Input className={''} value={formData.title}
                                                          onChange={(e) => {
                                                              this.onChangeData("title", e.target.value);
                                                          }} placeholder="请输入标题模板"/></Col>

                                </div>
                            </Row> : ''}
                            {templateFlag ? <Row>
                                <div style={{padding: 10}}>
                                    <Col span={4}>
                                        <div className={'myMediaTitle'}><span
                                            style={{color: 'red', position: 'absolute', top: 3, left: 40}}>*</span>内容模板：
                                        </div>
                                    </Col>
                                    <Col span={20}><Input className={''}
                                                          value={formData.content ? formData.content : ''}
                                                          onChange={(e) => {
                                                              this.onChangeData("content", e.target.value);
                                                          }} placeholder="请输入内容模板"/></Col>
                                </div>
                            </Row> : ''}
                            {templateFlag ? <Row>
                                <div style={{padding: 10}}>
                                    <Col span={4}>
                                        <div className={'myMediaTitle'}>跳转链接模板：
                                            {/*<span*/}
                                            {/*style={{color: 'red', position: 'absolute', top: 3}}>*</span>*/}
                                        </div>
                                    </Col>
                                    <Col span={20}><Input
                                        value={formData.spliceUrlTemplate ? formData.spliceUrlTemplate : ''}
                                        onChange={(e) => {
                                            this.onChangeData("spliceUrlTemplate", e.target.value);
                                        }} placeholder="请输入跳转链接模板"/></Col>
                                </div>
                            </Row> : ''}
                        </div>
                    </Modal>
                </div>
                {this.renderFooter()}
            </div>
        )
    }

    // 分页
    renderFooter = () => {
        let {params, count} = this.state;
        // 获取当前tab参数
        let {page} = params;
        let {start, size} = page;
        return (
            <div className={'pagination'} style={{marginTop: '5px'}}>
                <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
                <Pagination
                    showSizeChanger
                    current={start}
                    pageSize={size}
                    total={count}
                    showQuickJumper={true}
                    onChange={(page, pageSize) => this.pageChange(page, pageSize)}
                    onShowSizeChange={(page, pageSize) => this.pageChange(page, pageSize)}
                />
            </div>
        )
    };

    //分页
    pageChange(pageStart, pageSize) {
        let {params, activeKey} = this.state;
        let {page} = params;
        page.start = pageStart;
        page.size = pageSize;
        console.log(pageStart, pageSize, params);
        this.getDataSource(activeKey);
    }
}

export default NoticeTemplateManager;